const topCards = [
  'Beherrscht das 10-Finger-System',
  'Besucht regelmäßig Erste Hilfe Kurse',
  'Betreibt Extremsport',
  'Hat Abitur',
  'Hat Auslandserfahrung',
  'Hat die Mittlere Reife',
  'Hat ein gutes  Gedächtnis',
  'Hat ein hohes Durchhaltevermögen',
  'Hat ein sehr gutes Gehör',
  'Hat ein seriöses Auftreten',
  'Hat eine hohe Auffassungsgabe',
  'Hat eine hohe Mobilität',
  'Hat eine hohe Überzeugungskraft',
  'Hat eine schöne Handschrift',
  'Hat einen echten Doktortitel',
  'Hat einen grünen Daumen',
  'Hat einen Hochschulabschluss',
  'Hat einen IQ von 140',
  'Hat einen LKW-Führerschein',
  'hat einen Pilotenschein',
  'Hat Führungserfahrung',
  'Hat mit Überstunden kein Problem',
  'Ist äußerst höflich',
  'Ist belesen',
  'Ist charismatisch',
  'Ist ehrgeizig',
  'Ist empathisch',
  'Ist erfinderisch',
  'Ist esoterisch veranlagt',
  'Ist extrovertiert',
  'Ist fleißig',
  'Ist geduldig',
  'Ist gelassen',
  'Ist gelenkig',
  'Ist humorvoll',
  'Ist hygienisch',
  'Ist immer hochkonzentriert',
  'Ist kompromissbereit',
  'Ist kontaktfreudig',
  'Ist kreativ',
  'Ist kundenorientiert',
  'Ist lernbereit',
  'Ist Milliardär',
  'Ist modisch gekleidet',
  'Ist musikalisch',
  'Ist mutig',
  'Ist naturverbunden',
  'Ist Nichtraucher',
  'Ist optimistisch',
  'Ist Pazifist',
  'Ist Powerpoint-Experte',
  'Ist pragmatisch',
  'Ist redegewandt',
  'Ist reiselustig',
  'Ist risikobereit',
  'Ist sehr analytisch',
  'Ist sehr belastbar',
  'Ist sehr gesetzestreu',
  'Ist sehr loyal',
  'Ist sehr stark',
  'Ist sehr teamfähig',
  'Ist sehr tierlieb',
  'Ist sehr verhandlungssicher',
  'Ist sehr verständnisvoll',
  'Ist selbstironisch',
  'Ist selbstkritisch',
  'Ist selbstlos',
  'Ist selbstständig',
  'Ist sensibel',
  'Ist Single (glücklich)',
  'Ist sozial engagiert',
  'Ist sportlich',
  'Ist stark religiös',
  'Ist verantwortungsvoll',
  'Kann Arbeitszeiten flexibel gestalten',
  'Kann Gedanken lesen',
  'Kann gut und lecker kochen',
  'Kann improvisieren',
  'Kann lange die Luft anhalten',
  'Kann sehr schnell laufen',
  'Kann sehr schön singen',
  'Lebt vegetarisch',
  'Spielt gerne Brettspiele',
  'Spricht 4 Sprachen fließend',
  'Steht früh auf',
  'Verbreitet gute Laune',
  'Verhält sich immer Knigge-konform',
  'Versorgt sich selbst',
  'Weiß was Frauen wollen',
  'Ist gut vernetzt',
  'Ist handwerklich begabt',
  'Ist HSV-Fan',
  'Ist sehr selten krank',
  'Kann Google benutzen',
  'Kann gut Bälle fangen',
  'Kann sehr schnell laufen',
]

export { topCards }
